import { Slide } from "react-reveal";

const BrandingOffers = () => {
  return (
    <section className="solution-item-section section-spacing-50 world-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="solution-offers-container flex">
              <div className="solution-offers-textside">
                <div className="section-head width-600 section-spacing-40 no-padding-top">
                  <p className="section-tag boldTitle">OFFERS</p>
                  <Slide top>
                    <h2 className="section-title ntuna-text-fill">
                      What's Included
                    </h2>
                  </Slide>
                  <p className="section-subtitle font-inter-regular">
                    We don't just create visuals - we build complete brand
                    systems that define how your business looks, communicates,
                    and is remembered across every touch point.
                  </p>
                </div>
                <div className="section-body">
                  <ul className="offers-list-container">
                    <li className="offers-list">
                      <h3>Brand Strategy & Positioning</h3>
                      <ul>
                        <li>
                          <span>Business discovery & brand audit</span>
                        </li>
                        <li>
                          <span>Target audience definition</span>
                        </li>
                        <li>
                          <span>Brand positioning & differentiation</span>
                        </li>
                        <li>
                          <span>Brand personality & tone of voice</span>
                        </li>
                        <li>
                          <span>Message framework(how you communicate)</span>
                        </li>
                        <li>
                          <span>Brand story & narrative development</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Logo Design & Core Brand Identity</h3>
                      <ul>
                        <li>
                          <span>Custom logo design</span>
                        </li>
                        <li>
                          <span>Logo variations(primary, secondary, icon)</span>
                        </li>
                        <li>
                          <span>Color palette development</span>
                        </li>
                        <li>
                          <span>Typography systems</span>
                        </li>
                        <li>
                          <span>Iconography & visual symbols</span>
                        </li>
                        <li>
                          <span>Brand naming & slogan development</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Visual Identity System(Design Language)</h3>
                      <ul>
                        <li>
                          <span>
                            Design system(colors, fonts, spacing, layout)
                          </span>
                        </li>
                        <li>
                          <span>Visual patterns & graphic styles</span>
                        </li>
                        <li>
                          <span>Image direction & photography style</span>
                        </li>
                        <li>
                          <span>Grid system & layout structures</span>
                        </li>
                        <li>
                          <span>Consistency across digital & print</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Marketing & Promotional Design Assets</h3>
                      <ul>
                        <li>
                          <span>Flyers, Posters & Banners</span>
                        </li>
                        <li>
                          <span>Brochures & Company profiles</span>
                        </li>
                        <li>
                          <span>Ad Creatives (digital & print)</span>
                        </li>
                        <li>
                          <span>Campaign visuals & launch materials</span>
                        </li>
                        <li>
                          <span>Event & promotional branding</span>
                        </li>
                        <li>
                          <span>
                            Packaging design (products, labels, boxes)
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Social Media Branding & Content System</h3>
                      <ul>
                        <li>
                          <span>Social media profile branding</span>
                        </li>
                        <li>
                          <span>Content templates (posts, stories, ads)</span>
                        </li>
                        <li>
                          <span>Social Media Campaigns creatives</span>
                        </li>
                        <li>
                          <span>Visual consistency across platforms</span>
                        </li>
                        <li>
                          <span>Content design system for scalability</span>
                        </li>
                        <li>
                          <span>
                            3D, Motion graphics & animated brandind design
                          </span>
                        </li>
                        <li>
                          <span>
                            Video branding design (intros, outros, overlays)
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Corporate Branding & Business Assets</h3>
                      <ul>
                        <li>
                          <span>Business cards</span>
                        </li>
                        <li>
                          <span>Letterheads & document templates</span>
                        </li>
                        <li>
                          <span>Email & digital signatures</span>
                        </li>
                        <li>
                          <span>Presentation (pitch deck) templates</span>
                        </li>
                        <li>
                          <span>Internal brand assets(Stamps etc)</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Brand Guidelines & Governance</h3>
                      <ul>
                        <li>
                          <span>Complete brand guidelines document</span>
                        </li>
                        <li>
                          <span>Logo usage rules</span>
                        </li>
                        <li>
                          <span>Color & typography usage standards</span>
                        </li>
                        <li>
                          <span>Layout & design rules</span>
                        </li>
                        <li>
                          <span>Do's and don'ts for consistency</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Digital Brand Assets & UI Support</h3>
                      <ul>
                        <li>
                          <span>Website design assets</span>
                        </li>
                        <li>
                          <span>App UI branding elements</span>
                        </li>
                        <li>
                          <span>Icons & illustrations</span>
                        </li>
                        <li>
                          <span>Digital banners & visuals</span>
                        </li>
                        <li>
                          <span>UI consistency alignment</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Rebranding & Brand Evolution</h3>
                      <ul>
                        <li>
                          <span>Brand audit & performance review</span>
                        </li>
                        <li>
                          <span>Logo redesign & modernization</span>
                        </li>
                        <li>
                          <span>Visual identity refresh</span>
                        </li>
                        <li>
                          <span>Brand repositioning strategy</span>
                        </li>
                        <li>
                          <span>Consistency improvements</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Ongoing Design Support & Brand Growth</h3>
                      <ul>
                        <li>
                          <span>Continous design updates</span>
                        </li>
                        <li>
                          <span>Campaigns creatives</span>
                        </li>
                        <li>
                          <span>New assets creation</span>
                        </li>
                        <li>
                          <span>Brand expansion support</span>
                        </li>
                        <li>
                          <span>Design improvements over time</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandingOffers;
